export default __webpack_public_path__ + "static/image16-ea835761c292c7200f9a9009825ff16e.gif";